import Proptypes from 'prop-types';

export const DefaultProps = {
  operations: [],
  featured: false,
};

export const Props = {
  operations: Proptypes.arrayOf(Proptypes.object),
  featured: Proptypes.bool,
};
